import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router";

import "assets/scss/material-kit-pro-react.css?v=1.2.0";
import "assets/css/material-dashboard-react.css?v=1.4.0";
import indexRoutes from "routes/index.jsx";

import { Provider } from 'react-redux';
import { createStore } from 'redux';
import appState from './redux/reducers';
import { loadState, saveState } from './redux/localStorage';

const persistedState = loadState();
const store = createStore(
  appState,
  persistedState,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
store.subscribe(() => {
  saveState(store.getState());
});

var hist = createBrowserHistory();

ReactDOM.render(
  <Provider store={store}>
    <Router history={hist}>
      <Switch>
        {indexRoutes.map((prop, key) => {
          return <Route path={prop.path} key={key} component={prop.component} />;
        })}
      </Switch>
    </Router>
  </Provider>,
  document.getElementById("root")
);
